<div class="contents" *ngIf="!ShowEmpresas">
  <div class="dm-page-content mb-25">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <app-back-button />
          <div class="page-header">
            <div class="left-area">
              <span class="title">Empresas do Sector</span>
              <span class="sub-title">Pesquise, adicione e consulte todas as empresas do sector</span>
            </div>
            <div class="indicator" *ngIf="empresaCount">
              <div class="indicator">
                <div class="icon">
                  <img src="icons/dataflow-03.svg" alt="Country Icon" />
                </div>
                <div class="text-bg">
                  <span>{{empresaCount}} Empresas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="input_contetnt">
        <app-search-bar primaryBtnLabel="Adicionar nova Empresa" (onPrimaryBtnClick)="showDialog()"
          (formValueChange)="onFilterChange($event)" [showFilterBtn]="true"
          (onFilterBtnClick)="showFilterModal()"></app-search-bar>
      </div>

      <ng-container *ngIf="pagination.data; else noData">
        <div class="row">
          <div class="list grid">
            <app-card-empresa-03 *ngFor="let item of pagination.data; let i = index" class="col-6"
              [routerLink]="['detalhe-empresa', item.id]" [empresa]="item" [nome]="item.nome"
              [foto]="imagePreviewMap[item.id]" [endereco]="item.localizacao" [idade]="item.idade" [pais]="item.pais"
              [natureza]="item.subSector" [duracao]="item.duracao" [estado]="item.tipoEmpresa"
              [activo]="item.estadoContrato" [site]="item.url || item.email" [url]="item.url || item.email"
              [localizacao]="item.localizacao">
            </app-card-empresa-03>
          </div>
        </div>

        <div class="pagination-controls">
          <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
            [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
            (pageChange)="onPageChange($event)">
          </app-paginator-control>
        </div>
      </ng-container>

      <ng-template #noData>
        <div class="no-data">
          <app-data-void titulo="Nenhuma empresa encontrada"
            descricao="Clieque em Adicionar nova Empresa para criar uma."></app-data-void>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<p-toast></p-toast>

<!-- <app-add-representante *ngIf="ShowEmpresas"></app-add-representante> -->

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>